var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"5px"}},[_c('h6',[_vm._v("Информация пользователя")]),(this.$store.state.user != null)?_c('b',[_vm._v(_vm._s(this.$store.state.user.name))]):_vm._e(),_c('br'),(this.$store.state.user != null)?_c('b',[_vm._v(_vm._s(this.$store.state.user.email))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }